import { LABELS_CRUD_ACTION_CREATORS } from '../actions/labels_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
import { message } from 'antd';
import { LabelEntityType } from '../types/labels';

export const labelsRestCrudThunksForSupplier = new RestCrudThunks(
	'labels',
	'label',
	'label',
	'labels',
	LABELS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false
);

export const labelsOnPartsRestCrudThunksForSupplier = new RestCrudThunks(
	'part_labels',
	'label',
	'label',
	'part_labels',
	LABELS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'inventory/'
);

const fetchUtils = new FetchUtils();

export const associateLabelsWithEntity =
	(roleType: string) =>
	(targetCollectionName: LabelEntityType, entityId: number, labelIds: number[]) => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${roleType}/inventory/parts/${entityId}/labels`;

		return (dispatch) => {
			return new Promise<any>((resolve, reject) => {
				fetchUtils
					.put(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: { ids: labelIds },
					})
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							reject(d.message);
						} else {
							resolve(d.data);
						}
					})
					.catch((error) => {
						console.error('Error associating labels:', error);
						reject(error);
					});
			});
		};
	};
